import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { TooltipTextModule } from '../../tooltip-text/tooltip-text.module';
import { ProductPromotionsComponent } from './product-promotions.component';

@NgModule({
  declarations: [ProductPromotionsComponent],
  imports: [CommonModule, I18nModule, MatTooltipModule, TooltipIconModule, TooltipTextModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductPromotionsComponent: {
          component: ProductPromotionsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductPromotionsComponent],
})
export class ProductPromotionsModule {}
